import { createClient } from '@sanity/client'

const projectId = 'urerbr0z'
const dataset = 'production'

// Read-only client (no token needed for public dataset)
export const sanityReadClient = createClient({
  projectId,
  dataset,
  apiVersion: '2024-01-01',
  useCdn: false,
})

// Write client — needs REACT_APP_SANITY_TOKEN env var
export const sanityWriteClient = createClient({
  projectId,
  dataset,
  apiVersion: '2024-01-01',
  useCdn: false,
  token: process.env.REACT_APP_SANITY_TOKEN,
})
